import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// --- IMPORTS ---
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";
// eslint-disable-next-line
import Loader from "../../../../Components/Loader";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDateWithAMPM } from "../../../../common/Validations";
import {
  getEquipmentRentFormList,
  setEquipmentRentDocumentNumber,
} from "../../../../redux/feature/customer_app/customerSlice";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import CancelModal from "./ERFCancelModel";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useReactToPrint } from "react-to-print";
import ErfPrintout from "./ErfPrintout";
import EarlyClosureFormPrintout from "./EarlyClosureFormPrintout";
import ClosureRefundFormPrintout from "./ClosureRefundFormPrintout";
import DeliveryChallanPrintout from "./DeliveryChallanPrintout";
import ReceiptPrintOut from "./ReceiptPrintOut";
import toast from "react-hot-toast";
import ErfInvoiceModal from "./ErfInvoiceModal";
import ViewServiceDetailsModal from "./ViewServiceDetailsModal";
import CreateERFInvoiceModal from "./CreateERFInvoiceModal";

const ListERFHospital = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // --- 1. CONFIG & STATE ---
  localStorage.setItem("menu", "Equipment Rent");
  localStorage.setItem("submenu", "Hospital ERF List");

  // Select Data from Redux Store
  // We use optional chaining (?.) and default values (|| {}) to prevent crashes if state is loading
  const { data: reduxData, pagination } =
    useSelector((state) => state?.customer?.equipmentRentForm) || {};
  let userData = useSelector((state) => state?.user);

  const [getUser, setUser] = useState();
  const [getUserRole, setUserRole] = useState();

  useEffect(() => {
    const user = userData?.data?.userId || null;
    const userRole = userData?.data?.roles || null;
    setUser(user);
    setUserRole(userRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const [invoiceUserRoleData, serUserRoleData] = useState();

  const [showGenerateInvoiceModal, setShowGenerateInvoiceModal] =
    useState(false);

  useEffect(() => {
    if (userData?.data?.roles) {
      const allowedRoles = ["FI-EXECUTIVE"];
      const isAllowed = userData?.data?.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );
      serUserRoleData(isAllowed);
    }
  }, [userData]);
  // Local State for Table UI
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(
    CustomerConstants.ROW_REPORT_PER_PAGE[0],
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTxt, setSearchTxt] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [filterShow, setFilterShow] = useState(false);

  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  // eslint-disable-next-line
  const [userAllowed, setUserAllowed] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const [toggleClearRows, setToggleClearRows] = useState(false);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.statusHeader !== "Cancelled",
    );
    setSelectedRows(validRows);
  };

  // eslint-disable-next-line
  const [showDispatchModal, setShowDispatchModal] = useState(false);
  // eslint-disable-next-line
  const [selectedRow, setSelectedRow] = useState(null);

  const [showViewServiceModal, setShowViewServiceModal] = useState(false);
  const [viewServiceData, setViewServiceData] = useState(null);

  // eslint-disable-next-line
  const dispatchDetailedPage = (row) => {
    setSelectedRow(row);
    setShowDispatchModal(true);
  };
  // --- 1. ROLE IDENTIFICATION ---
  const isSalesPerson = useMemo(() => {
    return (
      userData?.data?.roles?.some((r) => r.roleId === "SALES-OFFICER") || false
    );
  }, [userData]);
  // eslint-disable-next-line
  const isSalesAdmin = useMemo(() => {
    return (
      userData?.data?.roles?.some((r) => r.roleId === "SALES-ADMIN") || false
    );
  }, [userData]);
  // console.log("isSalePerson", isSalesPerson, "ISSalesAdmin",isSalesAdmin)

  const isStorePerson = useMemo(() => {
    return userData?.data?.roles?.some((r) => r.roleId === "STORE") || false;
  }, [userData]);

  const isEarlyClosureStatus = (status) => {
    return status === "Early Closure" || status === "Partial Early Closure";
  };

  // const fetchData = async (page = 1, size = 10, search = "") => {
  const RESTRICTED_ROLES = ["SALES-PCD", "SALES-OFFICER"];
  // const fetchData = useCallback(
  //   async (page = 1, size = 10, search = "", filters = []) => {
  //     setLoading(true);
  //     try {
  //       const payload = {
  //         queryName: "HSPERFList",
  //         page,
  //         per_page: size,
  //         searchTerm: search,
  //         timeZone: "Asia/Calcutta",
  //         rowFilter: {},
  //       };

  //       // Role-based status filter
  //       let statusFilter = null;
  //       if (isSalesPerson) {
  //         statusFilter = ["In progress", "Approved"];
  //       } else if (isStorePerson) {
  //         statusFilter = ["Approved", "Dispatched"];
  //       }

  //       // If user has ANY restricted role → show only their own records
  //       // Otherwise (SALES-ADMIN, SALES-COORDINATOR, etc.) → show all records
  //       const isRestrictedRole = getUserRole?.some((r) =>
  //         RESTRICTED_ROLES.includes(r.roleId),
  //       );

  //       const userFilter =
  //         getUser && isRestrictedRole ? { createdBy: getUser } : null;

  //       const filterConditions = [];

  //       if (filters.length > 0) {
  //         filterConditions.push(...filters);
  //       }
  //       if (statusFilter) {
  //         filterConditions.push({ status: { $in: statusFilter } });
  //       }
  //       if (userFilter) {
  //         filterConditions.push(userFilter);
  //       }

  //       if (filterConditions.length > 0) {
  //         payload.rowFilter = { $and: filterConditions };
  //       }

  //       await dispatch(getEquipmentRentFormList(payload));
  //     } catch (error) {
  //       console.error("Error fetching list", error);
  //       toast.error("Error loading records");
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   // eslint-disable-next-line
  //   [getUser, getUserRole, isSalesPerson, isStorePerson, dispatch],
  // );
  //   setLoading(true);
  //   try {
  //     const payload = {
  //       queryName: "ERFList",
  //       page,
  //       per_page: size,
  //       searchTerm: search,
  //       timeZone: "Asia/Calcutta",
  //       rowFilter: {},
  //     };

  //     let statusFilter = null;

  //     if (isSalesPerson) {
  //       statusFilter = ["In progress", "Approved"];
  //     } else if (isStorePerson) {
  //       statusFilter = ["Approved", "Dispatched"];
  //     }

  //     if (statusFilter) {
  //       payload.rowFilter = {
  //         $and: [{ status: { $in: statusFilter } }],
  //       };
  //     }

  //     await dispatch(getEquipmentRentFormList(payload));
  //   } catch (error) {
  //     console.error("Error fetching list", error);
  //     toast.error("Error loading records");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // --- 3. TRIGGER FETCH ---

  // useEffect(() => {
  //   // Ensure we have userData before fetching to avoid empty role checks
  //   if (userData) {
  //     fetchData(currentPage, perPage, searchTxt);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPage, perPage, userData]);
  // useEffect(() => {
  // if (userData) {
  //   fetchData(currentPage, perPage, searchTxt, activeFilters);
  // }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPage, perPage, userData]);

  // ✅ Fix fetchData default size to match perPage state
  const fetchData = useCallback(
    async (
      page = 1,
      size = CustomerConstants.ROW_REPORT_PER_PAGE[0],
      search = "",
      filters = [],
    ) => {
      setLoading(true);
      try {
        const payload = {
          queryName: "HSPERFList",
          page,
          per_page: size,
          searchTerm: search,
          timeZone: "Asia/Calcutta",
          rowFilter: {},
        };

        let statusFilter = null;
        if (isSalesPerson) {
          statusFilter = ["In progress", "Approved"];
        } else if (isStorePerson) {
          statusFilter = ["Approved", "Dispatched"];
        }

        const isRestrictedRole = getUserRole?.some((r) =>
          RESTRICTED_ROLES.includes(r.roleId),
        );
        const userFilter =
          getUser && isRestrictedRole ? { createdBy: getUser } : null;

        const filterConditions = [];
        if (filters.length > 0) filterConditions.push(...filters);
        if (statusFilter)
          filterConditions.push({ status: { $in: statusFilter } });
        if (userFilter) filterConditions.push(userFilter);

        if (filterConditions.length > 0) {
          payload.rowFilter = { $and: filterConditions };
        }

        await dispatch(getEquipmentRentFormList(payload));
      } catch (error) {
        console.error("Error fetching list", error);
        toast.error("Error loading records");
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line
    [getUser, getUserRole, isSalesPerson, isStorePerson, dispatch],
  );
  useEffect(() => {
    if (getUser !== undefined && getUser !== null) {
      // ← wait until getUser is resolved
      fetchData(currentPage, perPage, searchTxt, activeFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, perPage, fetchData]);

  // --- HANDLERS ---
  const detailedPage = (row) => {
    // Save document number to store/local before navigating
    dispatch(setEquipmentRentDocumentNumber(row.documentNumber));
    navigate(CustomerConstants.CUSTOMER_V5_MR_ERF_DETAIL);
  };
  // eslint-disable-next-line
  const serviceDetailedPage = (row) => {
    // Save document number to store/local before navigating
    dispatch(setEquipmentRentDocumentNumber(row.documentNumber));
    navigate(CustomerConstants.CUSTOMER_V5_MR_ERF_SERVICE_PAGE);
  };
  // eslint-disable-next-line
  const handleCreate = () => {
    navigate(CustomerConstants.CUSTOMER_V5_MR_CREATE_ERF);
  };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  // };

  // const handlePerRowsChange = (newPerPage) => {
  //   setPerPage(newPerPage);
  //   setCurrentPage(1); // Reset to page 1 on size change
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage, searchTxt, activeFilters);
  };

  // ✅ Per page change
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    fetchData(1, newPerPage, searchTxt, activeFilters);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchData(1, perPage, searchTxt, activeFilters);
  };
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  //  Filter configuration for Gate Entry
  const filterColumns = [
    {
      id: "erfType",
      name: "ERF Type",
      selectorKey: "erfType",
    },
    {
      id: "erfStatus",
      name: "ERF Status",
      selectorKey: "erfStatus",
    },

    {
      id: "privilegeCase",
      name: "Privilege Case",
      selectorKey: "privilegeCase",
    },

    {
      id: "hospital",
      name: "Hospital",
      selectorKey: "hospital",
    },
    {
      id: "salePoint",
      name: "Sale Point",
      selectorKey: "salePoint",
    },
    {
      id: "patientName",
      name: "Patient Name",
      selectorKey: "patientName",
    },
    {
      id: "documentNumber",
      name: "ERF Number",
      selectorKey: "documentNumber",
    },
    {
      id: "netAmount",
      name: "Amount",
      selectorKey: "netAmount",
      numberRange: true,
    },
    {
      id: "createdAt",
      name: "Created Date",
      selectorKey: "createdAt",
      month: true,
    },
    //------------------------

    {
      id: "billingAddress",
      name: "Patient Address",
      selectorKey: "billingAddress",
    },

    {
      id: "mobileNr",
      name: "Mobile Number",
      selectorKey: "mobileNr",
    },
  ];

  //  Handle multi-column filter
  // const handleMultiColumnFilter = (filterResult) => {
  //   setLoading(true);
  //   try {
  //     const obj = {
  //       queryName: "ERFList",
  //       page: 1,
  //       per_page: 10,
  //       timeZone: "Asia/Calcutta",
  //     };

  //     if (filterResult && filterResult.$and && filterResult.$and.length > 0) {
  //       obj.rowFilter = filterResult;
  //     }
  //     // Dispatch to Redux (Thunk handles the API call)
  //     dispatch(getEquipmentRentFormList(obj));
  //   } catch (error) {
  //     console.error("Error fetching list", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const handleMultiColumnFilter = (filterResult) => {
  //   const filtersArray = Array.isArray(filterResult)
  //     ? filterResult
  //     : filterResult?.$and || [];

  //   setActiveFilters(filtersArray); // ← save filters
  //   setCurrentPage(1); // ← reset to page 1

  //   fetchData(1, perPage, searchTxt, filtersArray);
  // };

  const handleMultiColumnFilter = (filterResult) => {
    const filtersArray = Array.isArray(filterResult)
      ? filterResult
      : filterResult?.$and || [];
    setActiveFilters(filtersArray);
    setCurrentPage(1);
    fetchData(1, perPage, searchTxt, filtersArray); // ← pass directly, not from state
  };

  //  Handle filter cancel
  // const handleFilterCancel = () => {
  //   setFilterShow(false);
  // };
  const handleFilterCancel = () => {
    setFilterShow(false);
    setActiveFilters([]); // ← clear filters
    setCurrentPage(1);
    fetchData(1, perPage, searchTxt, []); // ← reload without filters
  };
  //create erf button
  useEffect(() => {
    if (userData?.data?.roles) {
      const allowedRoles = ["STORE"];

      const isAllowed = userData.data.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );

      setUserAllowed(isAllowed);
    }
  }, [userData]);

  //print
  //po print invocie
  const contentRef = useRef(null);
  const [getLoadingAdvice, setLoadingAdvice] = useState([]);
  // useReactToPrint declared at top level
  const handlePrint = useReactToPrint({
    contentRef,
    // documentTitle: `loadingAdvice_${getLoadingAdvice?.documentNumber || ""}`,
  });
  const handlePrintWithData = (row) => {
    setLoadingAdvice(row);

    // Wait for state updates before printing
    setTimeout(() => {
      handlePrint();
    }, 500);
  };

  //print for earlyclosure
  const contentRef1 = useRef(null);
  const [getEarlyClosure, setEarlyClosure] = useState(null);

  const earlyClosureHandlePrint = useReactToPrint({
    contentRef: contentRef1,
  });

  // const handleEarlyClosurePrintWithData = (row) => {
  //   setEarlyClosure(row);
  // };
  const handleEarlyClosurePrintWithData = (row) => {
    setEarlyClosure(row);
    setTimeout(() => {
      earlyClosureHandlePrint();
    }, 300);
  };

  useEffect(() => {
    if (getEarlyClosure) {
      earlyClosureHandlePrint();
    }
    // eslint-disable-next-line
  }, [getEarlyClosure]);

  //print for closureRefundForm
  const contentRef2 = useRef(null);
  const [getClosureRefundForm, setClosureRefundForm] = useState(null);

  const closureRefundFormHandlePrint = useReactToPrint({
    contentRef: contentRef2,
  });

  // const handleClosureRefundFormPrintWithData = (row) => {
  //   setClosureRefundForm(row);
  // };
  const handleClosureRefundFormPrintWithData = (row) => {
    setClosureRefundForm(row);
    setTimeout(() => {
      closureRefundFormHandlePrint();
    }, 300);
  };

  useEffect(() => {
    if (getClosureRefundForm) {
      closureRefundFormHandlePrint();
    }
    // eslint-disable-next-line
  }, [getClosureRefundForm]);

  //print for deliveryChallan
  const contentRef3 = useRef(null);
  const [getdeliveryChallan, setdeliveryChallan] = useState(null);

  const deliveryChallanHandlePrint = useReactToPrint({
    contentRef: contentRef3,
  });

  // const handledeliveryChallanPrintWithData = (row) => {
  //   setdeliveryChallan(row);
  // };
  const handledeliveryChallanPrintWithData = (row) => {
    setdeliveryChallan(row);
    setTimeout(() => {
      deliveryChallanHandlePrint();
    }, 300);
  };
  useEffect(() => {
    if (getdeliveryChallan) {
      deliveryChallanHandlePrint();
    }
    // eslint-disable-next-line
  }, [getdeliveryChallan]);

  //print for Receipt
  const contentRef4 = useRef(null);
  const [getReceipt, setReceipt] = useState(null);

  const ReceiptHandlePrint = useReactToPrint({
    contentRef: contentRef4,
  });

  // const handleReceiptPrintWithData = (row) => {
  //   setReceipt(row);
  // };
  const handleReceiptPrintWithData = (row) => {
    setReceipt(row);
    setTimeout(() => {
      ReceiptHandlePrint();
    }, 300);
  };

  useEffect(() => {
    if (getReceipt) {
      ReceiptHandlePrint();
    }
    // eslint-disable-next-line
  }, [getReceipt]);
  // --- 4. COLUMNS DEFINITION (Fixed keys to match API) ---

  const userROle = JSON.parse(localStorage.getItem("userData"));
  const hasDIspatchRole = userROle?.data?.roles?.some(
    (r) => r.roleId === "DISPATCH",
  );
  const userStore = JSON.parse(localStorage.getItem("userData"));
  const hasstoreRole = userStore?.data?.roles?.some(
    (r) => r.roleId === "STORE",
  );
  const shouldHideColumns = hasDIspatchRole || hasstoreRole;

  const columns = [
    {
      name: "Created Date/Time",
      selector: (row) => row.orderDate, // MATCHED API KEY
      cell: (row) => (
        <div>
          <span className="fw-medium">{formatDateWithAMPM(row.createdAt)}</span>
        </div>
      ),
      sortable: true,
      width: "190px",
    },
    {
      name: "ERF No",
      selector: (row) => row.documentNumber, // MATCHED API KEY
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row)}>
          {/* Fallback if documentNumber is missing */}
          {row.documentNumber || row.equipmentRentNr}
        </button>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "ERF Status",
      selector: (row) => row.erfStatus, // MATCHED API KEY
      cell: (row) => (
        <span>
          <TableStatusField status={row.erfStatus} />
        </span>
      ),
      width: "220px",
    },
    // {
    //   name: "Service",
    //   selector: (row) => row.documentNumber,
    //   cell: (row) => {
    //     const isEnabled =
    //       row.erfTypeCode?.toUpperCase() === "RE" &&
    //       ["ASNP", "DPD"].includes(row.erfStatusCode?.toUpperCase());

    //     return (
    //       <button
    //         className="btn btnInfo"
    //         onClick={() => serviceDetailedPage(row)}
    //         disabled={!isEnabled}
    //       >
    //         Service
    //       </button>
    //     );
    //   },
    //   sortable: true,
    //   width: "180px",
    // },
    //for testing
    /*  {
      name: "Invoice create",
      selector: (row) => row.erfStatus, // MATCHED API KEY
      cell: (row) => (
        <button className="btn btnTable" onClick={() => showEditInvoice(row)}>
          generate
        </button>
      ),
      width: "180px",
    }, */
    //   {
    //     name: "Invoice",
    //     cell: (row) => {
    //       const isDisabled = ["Dispatched"].includes(row?.erfStatus);

    //       return row?.invoiceCreated ? (
    //         <i
    //           className={`
    //   bi bi-receipt
    //   text-[26px]
    //   text-[#2d7a79]
    //   transition-colors duration-300
    //   cursor-pointer hover:text-[#4aa3a2]
    // `}
    //           onClick={() => showEditInvoice(row)}
    //         ></i>
    //       ) : (
    //         <button
    //           className="btn btnTable"
    //           disabled={!isDisabled}
    //           onClick={() => showEditInvoice(row)}
    //         >
    //           Generate
    //         </button>
    //       );
    //     },
    //     width: "150px",
    //     center: true,
    //     omit: !invoiceUserRoleData,
    //   },
    // {
    //   name: "Invoice",
    //   cell: (row) => {
    //     const validTypes = ["SL", "RE", "SLRE", "NR"].includes(
    //       row?.erfTypeCode,
    //     );

    //     const isAllowed =
    //       row?.erfTypeCode === "NR" ? true : row?.erfStatus === "Dispatched";

    //     const enableButton = validTypes && isAllowed;

    //     return row?.invoiceCreated ? (
    //       <i
    //         className="
    //       bi bi-receipt
    //       text-[26px]
    //       text-[#2d7a79]
    //       transition-colors duration-300
    //       cursor-pointer hover:text-[#4aa3a2]
    //     "
    //         onClick={() => showEditInvoice(row)}
    //       ></i>
    //     ) : (
    //       <button
    //         className="btn btnTable"
    //         disabled={!enableButton}
    //         onClick={() => showEditInvoice(row)}
    //       >
    //         Generate
    //       </button>
    //     );
    //   },
    //   width: "150px",
    //   center: true,
    //   omit: !invoiceUserRoleData,
    // },
    {
      name: "ERF Type & Privilege Case ",
      selector: (row) => row.erfType,
      cell: (row) => (
        <div>
          <span>
            <TableStatusField status={row.erfType} />
          </span>
          <p className="fw-bold mt-1">{row.privilegeCase}</p>
        </div>
      ),
      sortable: true,
      style: { justifyContent: "left" },
      width: "210px",
    },
    {
      name: "ERF For",
      selector: (row) => row.erfForType,
      cell: (row) => (
        // <span className="fw-bold text-primary">{row.erfForType}</span>
        <span
          style={{
            color: row.erfForType === "Hospital" ? "red" : "green",
            fontWeight: "bold",
          }}
        >
          {row.erfForType}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Hospital Name",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.hospitalName}</p>
          <p className="m-0 p-0 fw-bold">{row?.hospitalAssociateNumber}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Patient Details",
      selector: (row) => row.patientName,
      cell: (row) => (
        <div>
          <p className="fw-bold">{row.patientName}</p>
          <p>{row.contactNumber}</p>
          <p>{row.billingAddress}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Amount",
      selector: (row) => row?.netAmount || 0,
      cell: (row) => (
        <div
          className="fw fw-bold"
          style={{
            color: "blue",
            fontWeight: "bold",
          }}
        >
          {`${Number(row?.netAmount || 0).toFixed(2)} INR`}
        </div>
      ),
      right: true,
      width: "130px",
    },
    {
      name: "Sale Point",
      selector: (row) => row.salePoint,
      cell: (row) => (
        <div>
          <p>{row.salePoint}</p>
          <p className="fw fw-bold">{row.createdBy}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "120px",
    },

    {
      name: "Updated Remarks",
      cell: (row) => {
        const version = row?.version || "V0";
        const count = row?.updateRemarks?.length || 0;

        return (
          <>
            <span
              style={{ marginLeft: "12px" }}
              onClick={() => remarkItemShowModal(row?.updateRemarks || [])}
            >
              <i className="bi bi-calendar2-week iconTable"></i>
            </span>

            <span className="suppliersIcon">{`${count}/${version}`}</span>
          </>
        );
      },
      width: "160px",
    },
    {
      name: "Cancelled Remarks",
      cell: (row) => {
        const count = row?.cancellationHistory?.length || 0;

        return (
          <>
            <span
              style={{ marginLeft: "12px", cursor: "pointer" }}
              onClick={() =>
                cancelRemarkItemShowModal(row?.cancellationHistory || [])
              }
            >
              <i className="bi bi-journal-x iconTable"></i>
            </span>

            <span className="suppliersIcon">{`${count}`}</span>
          </>
        );
      },
      width: "160px",
    },

    {
      name: "View Updated Service",
      cell: (row) => (
        <>
          {row?.serviceHistory?.length > 0 && (
            <button
              className="btnInfo"
              // style={{ background: "linear-gradient(135deg,#16a34a,#15803d)", color: "#fff", border: "none", borderRadius: 8, padding: "5px 14px", fontWeight: 600, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", gap: 5 }}
              onClick={() => handleViewServiceDetails(row)}
            >
              <i className="bi bi-eye" /> View Details
            </button>
          )}
        </>
      ),
      width: "160px",
    },

    ...(reduxData?.some(
      (row) =>
        Array.isArray(row?.workflowActionLogs) &&
        row.workflowActionLogs.length > 0,
    )
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => {
              const hasLogs =
                Array.isArray(row?.workflowActionLogs) &&
                row.workflowActionLogs.length > 0;

              return (
                <div
                  style={{ width: "100%" }}
                  className="d-flex justify-content-center iconTable"
                >
                  <img
                    src="assets/img/newIcons/workflow.png"
                    alt="workflow"
                    style={{
                      width: "35px",
                      opacity: hasLogs ? 1 : 0.4,
                      cursor: hasLogs ? "pointer" : "not-allowed",
                    }}
                    className="mt-1"
                    onClick={
                      hasLogs
                        ? () => showStatusInfo(row.workflowActionLogs)
                        : undefined
                    }
                  />
                </div>
              );
            },
            sortable: true,
            width: "150px",
          },
        ]
      : []),

    {
      name: "WorkFlow Status",
      selector: (row) => row.status, // MATCHED API KEY
      cell: (row) => (
        <span>
          <TableStatusField status={row.status} />
        </span>
      ),
      width: "160px",
    },
    ...(!shouldHideColumns
      ? [
          {
            name: "Receipt",
            selector: (row) => row.attachments,
            cell: (row) => (
              <div
                onClick={() => handleReceiptPrintWithData(row)}
                className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-blue-600 cursor-pointer hover:bg-blue-600 hover:text-white hover:scale-110 hover:shadow-lg active:scale-95"
              >
                <i className="bi bi-printer text-lg fs-5"></i>
              </div>
            ),
            sortable: true,
            width: "130px",
          },
          {
            name: "Agreement",
            selector: (row) => row.attachments,
            cell: (row) => (
              <div
                onClick={() => handlePrintWithData(row)}
                className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-blue-600 cursor-pointer hover:bg-blue-600 hover:text-white hover:scale-110 hover:shadow-lg active:scale-95"
              >
                <i className="bi bi-printer text-lg fs-5"></i>
              </div>
            ),
            sortable: true,
            width: "130px",
          },

          {
            name: "Early Closure Form",
            selector: (row) => row.attachments,
            cell: (row) =>
              isEarlyClosureStatus(row.pcCallStatus) ? (
                <div
                  onClick={() => handleEarlyClosurePrintWithData(row)}
                  className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-blue-600 cursor-pointer hover:bg-blue-600 hover:text-white hover:scale-110 hover:shadow-lg active:scale-95"
                >
                  <i className="bi bi-printer text-lg fs-5"></i>
                </div>
              ) : (
                "--" //  hide when not matching
              ),
            sortable: true,
            width: "180px",
          },
          {
            name: "Closure Refund Form",
            selector: (row) => row.attachments,
            cell: (row) =>
              isEarlyClosureStatus(row.pcCallStatus) ? (
                <div
                  onClick={() => handleClosureRefundFormPrintWithData(row)}
                  className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-blue-600 cursor-pointer hover:bg-blue-600 hover:text-white hover:scale-110 hover:shadow-lg active:scale-95"
                >
                  <i className="bi bi-printer text-lg fs-5"></i>
                </div>
              ) : (
                "--" //  hide when not matching
              ),
            sortable: true,
            width: "180px",
          },

          {
            name: "Delivery Challan",
            selector: (row) => row.attachments,
            cell: (row) => (
              <div
                onClick={() => handledeliveryChallanPrintWithData(row)}
                className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-blue-600 cursor-pointer hover:bg-blue-600 hover:text-white hover:scale-110 hover:shadow-lg active:scale-95"
              >
                <i className="bi bi-printer text-lg fs-5"></i>
              </div>
            ),
            sortable: true,
            width: "180px",
          },
        ]
      : []),
  ];

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const remarkLineItemColInfo = [
    {
      name: "Remarks",
      cell: (row) => <span>{row?.remark || ""} </span>,
      width: "250px",
    },
    {
      name: "Version",
      cell: (row) => <span>{row?.version || ""} </span>,
      width: "180px",
    },
  ];
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const remarkItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(remarkLineItemColInfo);
    setModalTitle("ERF Remarks / Version");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const [cancelItemLevelModalShow, setCancelItemLevelModalShow] =
    useState(false);

  const cancelRemarkLineItemColInfo = [
    {
      name: "Remarks",
      cell: (row) => <span>{row?.remark || ""} </span>,
      width: "180px",
    },
    {
      name: "Cancelled At",
      cell: (row) => <span>{formatDateWithAMPM(row?.cancelledAt) || ""} </span>,
      width: "220px",
    },
  ];

  const cancelRemarkItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(cancelRemarkLineItemColInfo);
    setModalTitle("ERF Cancel Remarks");
    setCancelItemLevelModalShow(true);
  };
  const cancelItemLevelHideModal = () => {
    setCancelItemLevelModalShow(false);
  };

  const [getModalEditInvoice, setModalEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  // eslint-disable-next-line
  const showEditInvoice = (rowData) => {
    setModalEditInvoice(true);
    setInvoiceData(rowData);
  };
  const hideInvoiceModal = () => {
    setModalEditInvoice(false);
    setInvoiceData(null);
    // setEwayBillData(null);
  };
  const handleViewServiceDetails = (row) => {
    setViewServiceData(row);
    setShowViewServiceModal(true);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            {/* --- Header Section --- */}
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">
                  Equipment Rent Form List For Hospital
                </h2>
                <p className="subText">List of active and closed rentals</p>
              </Col>

              <Col xs={12} md={3} lg={3} className="mt-3">
                {/* <SearchField
                  name="searchKey"
                  value={searchTxt}
                  onChange={(e) => setSearchTxt(e.target.value)}
                  onClick={() => fetchData(1, perPage, searchTxt)}
                  placeholder="Search..."
                /> */}
                <SearchField
                  name="searchKey"
                  value={searchTxt}
                  onChange={(e) => setSearchTxt(e.target.value)}
                  onClick={handleSearch}
                  placeholder="Search..."
                />
              </Col>

              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <MultiColumnFilter
                    columns={filterColumns}
                    data={reduxData}
                    onFilter={handleMultiColumnFilter}
                    onCancel={handleFilterCancel}
                    output="and"
                  />
                )}
              </Col>
            </Row>

            {/* --- Table Accordion --- */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-down" : "bi-chevron-right"
                        }`}
                        onClick={() => setCardVisible(!isCardVisible)}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RL</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Rental List</span>
                      <span className="subHeaderTitle">
                        View Details and Status
                      </span>
                    </Col>

                    {/* Create Button in Accordion Header */}
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/* {!invoiceUserRoleData && 
                     <Col xs={4} md={2} lg={2} className="ms-auto">
                          <button className="btnTable" onClick={() => setShowGenerateInvoiceModal(true)}>
                             Generate Invoice
                          </button>
                      </Col>
} */}
                      {invoiceUserRoleData && (
                        <Col xs={4} md={2} lg={2} className="ms-auto">
                          <button
                            className="btnTable"
                            onClick={() => {
                              // Validate that at least one row is selected
                              if (getSelectedRows.length === 0) {
                                toast.error(
                                  "Please select at least one ERF to generate invoice.",
                                );
                                return;
                              }

                              // Check all selected rows have the same hospitalAssociateNumber
                              const hospitalNrs = getSelectedRows.map(
                                (row) => row.hospitalAssociateNumber,
                              );
                              const uniqueHospitalNrs = [
                                ...new Set(hospitalNrs),
                              ];

                              if (uniqueHospitalNrs.length > 1) {
                                toast.error(
                                  `Selected ERFs belong to different hospitals. Please select ERFs from the same hospital only.\n(Found: ${uniqueHospitalNrs.join(", ")})`,
                                );
                                return;
                              }

                              setShowGenerateInvoiceModal(true);
                            }}
                          >
                            Generate Invoice
                          </button>
                        </Col>
                      )}

                      <Col xs={3} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          // disabled={getSelectedRows.length === 1 ? false : true}
                          //                        disabled={
                          //   getSelectedRows.length === 1 &&
                          //   getSelectedRows[0]?.erfStatus !== "Cancelled"
                          //     ? false
                          //     : true
                          // }
                          disabled={
                            getSelectedRows.length === 1 &&
                            ![
                              "Cancelled",
                              "Ready To Dispatch",
                              "Dispatched",
                            ].includes(getSelectedRows[0]?.erfStatus)
                              ? false
                              : true
                          }
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12}>
                        {/* <Loader isLoading={loading || status} /> */}
                        <DataTable
                          title=""
                          columns={columns}
                          // Directly pass the data array from Redux
                          data={reduxData || []}
                          pagination
                          paginationServer
                          paginationPerPage={perPage}
                          // Pass total rows from Redux pagination
                          paginationTotalRows={pagination?.total || 0}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_REPORT_PER_PAGE
                          }
                          // Handlers
                          onChangePage={handlePageChange}
                          onChangeRowsPerPage={handlePerRowsChange}
                          selectableRows
                          highlightOnHover
                          pointerOnHover
                          persistTableHead={false}
                          onSelectedRowsChange={handleRowSelected}
                          // noDataComponent={
                          //   <div className="p-4 text-center text-muted">
                          //     No records found
                          //   </div>
                          // }
                          clearSelectedRows={toggleClearRows}
                        />
                      </Col>
                    </Row>
                    <div style={{ display: "none" }}>
                      <ErfPrintout ref={contentRef} data={getLoadingAdvice} />
                    </div>
                    <div style={{ display: "none" }}>
                      <EarlyClosureFormPrintout
                        ref={contentRef1}
                        data={getEarlyClosure}
                      />
                    </div>
                    <div style={{ display: "none" }}>
                      <ClosureRefundFormPrintout
                        ref={contentRef2}
                        data={getClosureRefundForm}
                      />
                    </div>
                    <div style={{ display: "none" }}>
                      <DeliveryChallanPrintout
                        ref={contentRef3}
                        data={getdeliveryChallan}
                      />
                    </div>
                    <div style={{ display: "none" }}>
                      <ReceiptPrintOut
                        key={
                          getReceipt?.documentNumber || "Receipt-Printout-key"
                        }
                        ref={contentRef4}
                        data={getReceipt}
                        isExtension={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CancelModal
        title="Cancel the ERF Form"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
        //        onSuccess={() => {
        //   cancelModalHide();
        //   fetchData();
        // }}
        onSuccess={() => {
          cancelModalHide();
          setSelectedRows([]); //
          setToggleClearRows((prev) => !prev); //
          fetchData(currentPage, perPage, searchTxt, activeFilters);
        }}
      />
      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <CommonItemLevelDatatableModal
        show={cancelItemLevelModalShow}
        onHide={() => cancelItemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <ErfInvoiceModal
        show={getModalEditInvoice}
        onHide={() => hideInvoiceModal()}
        invoiceinfo={invoiceData}
        // onsuccessdata={handleSuccessData}
        // viewInvoiceData={viewInvoiceData}
      />
      <ViewServiceDetailsModal
        show={showViewServiceModal}
        onHide={() => setShowViewServiceModal(false)}
        data={viewServiceData}
      />
      <CreateERFInvoiceModal
        show={showGenerateInvoiceModal}
        onHide={() => setShowGenerateInvoiceModal(false)}
        selectedRows={getSelectedRows}
        modaldata={{
          modalTitle: "Generate Invoice",
          navigate: CustomerConstants.CUSTOMER_V5_MR_ERF_INVOICE_PAGE, // your target route
        }}
      />
    </main>
  );
};

export default ListERFHospital;
